<ng-container
  *ngFor="let event of _.events; let first = first; let last = last"
>
  <timeline-item
    class="no-y-margin"
    [event]="event"
    [last]="last"
    [first]="first"
    [showTooltip]="showTooltip"
  >
  </timeline-item>
</ng-container>
